import React, {useEffect} from 'react'
import Navbar from '../pages/Navbar';
import Footer from '../pages/Footer';
import { Link } from 'react-router-dom';
import Banner from './Banner';

function Layout({ title, path, children }) {

  useEffect(() => {
    // Scroll to the top of the page when the component is mounted
    window.scrollTo(0, 0);
  }, []);


  return (
    <>
      <Navbar />
      <header className="site-header align-items-center">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-8 col-12 mb-5">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">Home</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    {path}
                  </li>
                </ol>
              </nav>
              <h2 className="text-white">{title}</h2>
            </div>
          </div>
        </div>
      </header>

      <Banner/>

      <main>{children}</main>

      <Footer />
    </>
  )
}

export default Layout
